const adminModelCallLogs = {
  actions: {
    open: 'Open actions for {{requestId}}',
    refresh: 'Refresh',
    view: 'View',
  },
  advancedFilters: {
    done: 'Done',
    title: 'More filters',
  },
  columnSelector: {
    label: 'Choose call log table columns',
    trigger: 'Columns',
  },
  description:
    'Inspect model gateway runtime routing, billing, fallback, quota, and failure details.',
  drawer: {
    completionTokens: 'Completion tokens',
    copyFailed: 'Copy failed. Please copy manually.',
    copyRequestId: 'Copy Request ID',
    copySuccess: 'Request ID copied',
    errorMessage: 'Error message',
    fallbackReason: 'Fallback reason',
    finalModel: 'Final model',
    finishedAt: 'Finished at',
    inputCost: 'Input cost',
    interfaceType: 'Upstream interface',
    keyId: 'Key ID',
    outputCost: 'Output cost',
    outputProtocol: 'Output protocol',
    pricingSource: 'Pricing source',
    promptTokens: 'Prompt tokens',
    quotaAction: 'Quota action',
    quotaMessage: 'Quota message',
    quotaMetric: 'Quota metric',
    quotaRule: 'Quota rule',
    requestId: 'Request ID',
    requestedModel: 'Requested model',
    resolvedModel: 'Resolved model',
    routeKind: 'Route kind',
    sections: {
      basic: 'Basic',
      controls: 'Fallback and quota',
      failure: 'Failure diagnostics',
      key: 'Key and pricing',
      route: 'Model routing',
      usage: 'Usage and cost',
    },
    title: 'Call detail / {{requestId}}',
  },
  empty: 'No call logs',
  errorCategories: {
    auth_error: 'Auth error',
    expired_key: 'Expired key',
    internal_error: 'Internal error',
    model_not_allowed: 'Model not allowed',
    probe_failed: 'Probe failed',
    protocol_mismatch: 'Protocol mismatch',
    quota_exceeded: 'Quota exceeded',
    stream_denied: 'Streaming denied',
    upstream_4xx: 'Upstream 4xx',
    upstream_5xx: 'Upstream 5xx',
    upstream_connection_error: 'Upstream connection error',
    upstream_invalid_response: 'Invalid upstream response',
    upstream_timeout: 'Upstream timeout',
    validation_error: 'Validation error',
  },
  errorDescription: 'Try again later, or check whether this admin still has model gateway access.',
  errorDescriptionWithDetail: 'Backend returned: {{detail}}',
  errorTitle: 'Failed to load call logs',
  failureStages: {
    auth: 'Auth',
    internal: 'Internal',
    internal_model_eval: 'Internal model eval',
    internal_model_runtime: 'Internal model runtime',
    model_resolution: 'Model resolution',
    probe: 'Model probe',
    protocol_check: 'Protocol check',
    quota_precheck: 'Quota precheck',
    stream_runtime: 'Stream runtime',
    upstream_decode: 'Upstream decode',
    upstream_dispatch: 'Upstream dispatch',
  },
  fallback: {
    none: 'Not triggered',
    triggered: 'Triggered',
  },
  filters: {
    allErrorCategories: 'All error categories',
    allFailureStages: 'All failure stages',
    allFallback: 'All fallback',
    allProviders: 'All providers',
    allStatuses: 'All statuses',
    advanced: 'More filters',
    advancedLabel: 'Open more filters, {{count}} advanced filters enabled',
    clear: 'Clear filters',
    clearAdvanced: 'Clear advanced filters',
    errorCategoryLabel: 'Filter error category',
    failureStageLabel: 'Filter failure stage',
    fallbackLabel: 'Filter fallback',
    keyIdLabel: 'Filter key UUID',
    keyIdPlaceholder: 'Distribution key UUID',
    modelLabel: 'Filter model name',
    modelPlaceholder: 'Model name',
    providerLabel: 'Filter provider',
    requestIdLabel: 'Search Request ID',
    requestIdPlaceholder: 'Request ID',
    statusLabel: 'Filter status',
  },
  pagination: {
    next: 'Next',
    pageSize: '{{count}} / page',
    previous: 'Previous',
  },
  providers: {
    anthropic: 'Anthropic',
    deepseek: 'DeepSeek',
    gemini: 'Gemini',
    glm: 'GLM',
    kimi: 'Kimi',
    minimax: 'MiniMax',
    openai: 'OpenAI',
    qwen: 'Qwen',
    xai: 'xAI',
  },
  quota: {
    none: 'Not triggered',
    triggered: 'Triggered',
  },
  retry: 'Retry',
  status: {
    failure: 'Failed',
    success: 'Succeeded',
  },
  summary: {
    avgLatency: 'Avg latency',
    cost: 'Total cost',
    requests: 'Requests',
    successRate: 'Success rate',
    totalTokens: 'Total tokens',
  },
  table: {
    actions: 'Actions',
    cost: 'Cost',
    error: 'Error',
    errorCategory: 'Error category',
    failureStage: 'Failure stage',
    fallback: 'Fallback',
    key: 'Key',
    latency: 'Latency',
    provider: 'Provider',
    quota: 'Quota',
    requestId: 'Request ID',
    route: 'Model route',
    source: 'Source',
    startedAt: 'Started at',
    status: 'Status',
    statusCode: 'Status code',
    tokens: 'Tokens',
  },
  timeRange: {
    apply: 'Apply',
    ariaLabel: 'Filter time range',
    close: 'Close',
    customRange: 'Custom range',
    dialogLabel: 'Choose call log time range',
    from: 'Start time',
    compactPresets: {
      custom: 'Custom',
      last24h: '24h',
      last30d: '30d',
      last7d: '7d',
    },
    presets: {
      custom: 'Custom range',
      last24h: 'Last 24 hours',
      last30d: 'Last 30 days',
      last7d: 'Last 7 days',
    },
    quickRanges: 'Quick ranges',
    to: 'End time',
    valueTitle: '{{from}} to {{to}}',
  },
  title: 'Call logs',
  workspaceLabel: 'Model call logs workspace',
}

export default adminModelCallLogs
